import LogRocket from 'logrocket'
import { appConfig } from 'src/constants'
import { useAuthStore } from 'src/stores/auth'

let setUserToLogRocket

export default async ({ app, store }) => {
  if (!appConfig.LOG_ROCKET_APP_ID) return

  const authStore = useAuthStore()
  LogRocket.init(appConfig.LOG_ROCKET_APP_ID, {
    release: appConfig.VUE_APP_BUILD_NUM || '',
    shouldParseXHRBlob: true,
    network: {
      requestSanitizer: (request) => {
        if (request.url.includes('smartlook.cloud')) return null
        return request
      },
    },
  })

  app.config.errorHandler = (err, vm, info) => {
    LogRocket.captureException(err, {
      extra: { vm, info },
    })
  }

  setUserToLogRocket = () => {
    const isLoggedIn = authStore.isLoggedIn,
      customerExists = authStore.customerExists

    if (isLoggedIn && customerExists) {
      const currentUserIdNumber = authStore.currentUser?.userId || '',
        currentUserIdentity = authStore.currentUserIdentity,
        currentUserName = authStore.currentUserName

      LogRocket.identify(currentUserIdNumber, {
        name: currentUserName,
        email: currentUserIdentity,

        // Add your own custom user variables here, ie:
        // subscriptionType: 'pro'
      })
    } else LogRocket.identify('anonymous')
  }
}

export { setUserToLogRocket }
